<!--
  Error Summary Table Component
  @component ErrorSummaryTable
-->
<template>
  <div class="error-summary-table">
    <q-table
      :rows="errors"
      :columns="columns"
      :loading="loading"
      row-key="id"
      flat
      bordered
      dense>
      
      <template #top>
        <h6 class="q-ma-none">Error Summary</h6>
      </template>

      <template #body-cell-actions="props">
        <q-td :props="props">
          <q-btn
            :icon="symRoundedRefresh"
            label="Retry"
            color="warning"
            size="sm"
            @click="$emit('retry', props.row)" />
        </q-td>
      </template>

      <template #no-data>
        <div class="full-width row flex-center">
          <span>No errors found</span>
        </div>
      </template>
    </q-table>
  </div>
</template>

<script setup lang="ts">
import { symRoundedRefresh } from '@quasar/extras/material-symbols-rounded'
import { computed } from 'vue'
import type { ErrorSummary } from '../types'

interface Props {
  errors: ErrorSummary[]
  loading?: boolean
}

interface Emits {
  retry: [error: ErrorSummary]
  resolve: [error: ErrorSummary]
}

withDefaults(defineProps<Props>(), {
  loading: false
})

defineEmits<Emits>()

const columns = computed(() => [
  {
    name: 'error_message',
    label: 'Error Message',
    field: 'error_message',
    align: 'left' as const,
    sortable: true
  },
  {
    name: 'error_count',
    label: 'Count',
    field: 'error_count',
    align: 'center' as const,
    sortable: true
  },
  {
    name: 'last_occurred',
    label: 'Last Occurred',
    field: 'last_occurred',
    align: 'left' as const,
    sortable: true,
    format: (val: string) => new Date(val).toLocaleString()
  },
  {
    name: 'actions',
    label: 'Actions',
    field: 'actions',
    align: 'center' as const
  }
])
</script>

<style lang="scss" scoped>
.error-summary-table {
  .q-table {
    .q-td {
      white-space: nowrap;
    }
  }
}
</style> 